"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FULL_ROUTES = void 0;
const BASE_1 = require("./BASE.js");
const PARAMS_1 = require("./PARAMS.js");
function routeBuilder(...rest) {
    return `/${rest.join('/')}`;
}
exports.FULL_ROUTES = {
    ADD_APP: routeBuilder(BASE_1.BASE_ROUTES.DATA_SECURITY, BASE_1.BASE_ROUTES.APPLICATION_SETUP, BASE_1.BASE_ROUTES.ADD_APP),
    ADMIN: routeBuilder(BASE_1.BASE_ROUTES.ADMIN),
    CONFIRM_LINK: routeBuilder(BASE_1.BASE_ROUTES.CONFIRM_LINK),
    DASHBOARD: routeBuilder(BASE_1.BASE_ROUTES.DASHBOARD),
    DATA_DICTIONARY: routeBuilder(BASE_1.BASE_ROUTES.DATA_DICTIONARY),
    DATA_SECURITY: routeBuilder(BASE_1.BASE_ROUTES.DATA_SECURITY),
    DATA_SECURITY_API_VOLUME: routeBuilder(BASE_1.BASE_ROUTES.DATA_SECURITY, BASE_1.BASE_ROUTES.API_VOLUME),
    DATA_SECURITY_APPLICATION_SETUP: routeBuilder(BASE_1.BASE_ROUTES.DATA_SECURITY, BASE_1.BASE_ROUTES.APPLICATION_SETUP),
    DATA_SECURITY_DATA_ACCESS: routeBuilder(BASE_1.BASE_ROUTES.DATA_SECURITY, BASE_1.BASE_ROUTES.DATA_ACCESS),
    DATA_SECURITY_DATA_ACCESS_ACCESS_AUDIT: routeBuilder(BASE_1.BASE_ROUTES.DATA_SECURITY, BASE_1.BASE_ROUTES.DATA_ACCESS, BASE_1.BASE_ROUTES.ACCESS_AUDIT),
    DATA_SECURITY_DATA_ACCESS_ACCESS_COMPARE: routeBuilder(BASE_1.BASE_ROUTES.DATA_SECURITY, BASE_1.BASE_ROUTES.DATA_ACCESS, BASE_1.BASE_ROUTES.ACCESS_COMPARISON),
    DATA_SECURITY_DATA_ACCESS_ACCESS_EXPLAINER: routeBuilder(BASE_1.BASE_ROUTES.DATA_SECURITY, BASE_1.BASE_ROUTES.DATA_ACCESS, BASE_1.BASE_ROUTES.ACCESS_EXPLAINER),
    DATA_SECURITY_MONITORS: routeBuilder(BASE_1.BASE_ROUTES.DATA_SECURITY, BASE_1.BASE_ROUTES.MONITORS),
    DATA_SECURITY_SETUP_AUDIT_TRAIL: routeBuilder(BASE_1.BASE_ROUTES.DATA_SECURITY, BASE_1.BASE_ROUTES.SETUP_AUDIT_TRAIL),
    EXPORT: routeBuilder(BASE_1.BASE_ROUTES.EXPORT, PARAMS_1.PARAMS.ID),
    FORGOT_PASSWORD: routeBuilder(BASE_1.BASE_ROUTES.FORGOT_PASSWORD),
    INITIATIVES: routeBuilder(BASE_1.BASE_ROUTES.INITIATIVES),
    INITIATIVES_DETAIL: routeBuilder(BASE_1.BASE_ROUTES.INITIATIVES, PARAMS_1.PARAMS.ID),
    INTEGRATIONS_OIDC: routeBuilder(BASE_1.BASE_ROUTES.INTEGRATIONS, BASE_1.BASE_ROUTES.OIDC),
    INTEGRATIONS_SALESFORCE: routeBuilder(BASE_1.BASE_ROUTES.INTEGRATIONS, BASE_1.BASE_ROUTES.SALESFORCE),
    INVITATION: routeBuilder(BASE_1.BASE_ROUTES.INVITATION, PARAMS_1.PARAMS.TOKEN),
    ISSUES: routeBuilder(BASE_1.BASE_ROUTES.ISSUES),
    ISSUES_ARCHIVED: routeBuilder(BASE_1.BASE_ROUTES.ISSUES, BASE_1.BASE_ROUTES.ARCHIVED),
    ISSUES_SNOOZED: routeBuilder(BASE_1.BASE_ROUTES.ISSUES, BASE_1.BASE_ROUTES.SNOOZED),
    LOGIN: routeBuilder(BASE_1.BASE_ROUTES.LOGIN),
    MONITORS: routeBuilder(BASE_1.BASE_ROUTES.DATA_SECURITY, BASE_1.BASE_ROUTES.APPLICATION_SETUP, PARAMS_1.PARAMS.ID),
    ONBOARDING_CONFIRM: routeBuilder(BASE_1.BASE_ROUTES.ONBOARDING, BASE_1.BASE_ROUTES.CONFIRM),
    ONBOARDING_CONNECT: routeBuilder(BASE_1.BASE_ROUTES.ONBOARDING, BASE_1.BASE_ROUTES.CONNECT),
    ONBOARDING_SYNC: routeBuilder(BASE_1.BASE_ROUTES.ONBOARDING, BASE_1.BASE_ROUTES.SYNC),
    ORGANIZATION_CONFIRM: routeBuilder(BASE_1.BASE_ROUTES.ORGANIZATION, BASE_1.BASE_ROUTES.CONFIRM),
    ORGANIZATION_SYNC: routeBuilder(BASE_1.BASE_ROUTES.ORGANIZATION, BASE_1.BASE_ROUTES.SYNC),
    PERISCOPE: routeBuilder(BASE_1.BASE_ROUTES.PERISCOPE),
    RESET_PASSWORD: routeBuilder(BASE_1.BASE_ROUTES.RESET_PASSWORD, PARAMS_1.PARAMS.TOKEN),
    SELECT_ORGANIZATION: routeBuilder(BASE_1.BASE_ROUTES.SELECT_ORGANIZTION),
    SETTINGS: routeBuilder(BASE_1.BASE_ROUTES.SETTINGS),
    SETTINGS_INTEGRATIONS: routeBuilder(BASE_1.BASE_ROUTES.SETTINGS, BASE_1.BASE_ROUTES.INTEGRATIONS),
    SETTINGS_JIRA: routeBuilder(BASE_1.BASE_ROUTES.SETTINGS, BASE_1.BASE_ROUTES.JIRA),
    SETTINGS_ORGANIZATION: routeBuilder(BASE_1.BASE_ROUTES.SETTINGS, BASE_1.BASE_ROUTES.ORGANIZATION),
    SETTINGS_SLACK: routeBuilder(BASE_1.BASE_ROUTES.SETTINGS, BASE_1.BASE_ROUTES.SLACK),
    SETTINGS_TEAM: routeBuilder(BASE_1.BASE_ROUTES.SETTINGS, BASE_1.BASE_ROUTES.TEAM),
    SETTINGS_USER: routeBuilder(BASE_1.BASE_ROUTES.SETTINGS, BASE_1.BASE_ROUTES.USER),
    SHARED_VIEW: routeBuilder(BASE_1.BASE_ROUTES.SHARED_VIEW, PARAMS_1.PARAMS.ID),
    SIGN_UP: routeBuilder(BASE_1.BASE_ROUTES.SIGN_UP),
    SYNC: routeBuilder(BASE_1.BASE_ROUTES.SETTINGS, BASE_1.BASE_ROUTES.SYNC),
    TAGS: routeBuilder(BASE_1.BASE_ROUTES.TAGS),
    TAGS_MANAGE: routeBuilder(BASE_1.BASE_ROUTES.TAGS, BASE_1.BASE_ROUTES.MANAGE),
    TIMELINE: routeBuilder(BASE_1.BASE_ROUTES.TIMELINE),
    TOKEN: routeBuilder(BASE_1.BASE_ROUTES.TOKEN, PARAMS_1.PARAMS.TOKEN)
};
//# sourceMappingURL=FULL.js.map